// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Header, Icon } from "semantic-ui-react";

// Styles
import styles from "./styles.module.css";

const EmptyList = ({ text = "", icon = "" }) => {
	return (
		<div className={styles.emptyContainer}>
			<Header as="h5" icon className={styles.text}>
				<Icon name={icon} />
				{text}
			</Header>
		</div>
	);
};

EmptyList.propTypes = {
	text: PropTypes.string,
	icon: PropTypes.string,
};

export default EmptyList;
